<template>
  <div class="container">
    <div class="home">
      <div class="home-banner">
        <img class="banner-bg" src="@/assets/banner-home.png" alt="">
        <div class="textBox typeArea">
          <p class="centerBanner animated zoomIn" style="font-weight: bold;">体验生命周期动态模拟（DSS）</p>
          <p class="title_secound animated centerBanner  zoomIn">释放你数据的能量</p>
        </div>
      </div>
      <div class="home-mode" id="newest" style="height: 582px;">
        <div class="mode-cont">
          <div class="cont-title">
            <span class="title-en">ABOUT</span><span class="title-ch">关于部盾</span>
            <img class="title-box" src="@/assets/box.png" alt="">
          </div>
          <div class="box">
            <div class="img-box" style="width: 515px;height: 293px;overflow:hidden;display:inline-block;">
              <img class="box-img" src="@/assets/cont-bg1.png" alt="">
            </div>
            <div class="box-cont">
              <div style="color:#333;font-weight:bold;">引用一个例子：Palantir (PLTR)</div>
              <div>“We build the world's leading software for data-driven decisions and operations.”</div>
              <div>“我们开发世界一流的软件，用于数据驱动的决策和运行”。</div>
              <div>“Our business allows management talk with data.”</div>
              <div>“我们的业务是使管理可以同数据交流”。</div>
              <div style="color:#333;font-weight:bold;">部盾的数字化决策产品：</div>
              <div>部盾信息科技有限公司致力于大数据在管理及业务决策中的应用：使用机构或企业的真实数据，运用集成化决策分析和建模技术，对实体运行进行模拟、还原和预测，为决策人员提供问题清晰、指向准确、简便易用的决策工具。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-mode" id="industry" style="height: 566px;">
        <div class="mode-cont">
          <div class="cont-title">
            <span class="title-en" style="color:#FFFFFF;opacity: 0.27;">INDUSTRY</span><span class="title-ch">行业聚焦</span>
            <img class="title-box" src="@/assets/box.png" alt="">
          </div>
          <div class="box" style="margin-top: 4em;">
            <div class="box-left">
              随着数字化转型的快速发展，出现了数据条件比较完备，对数据在数字化辅助决策中的预期作用相对明确的领域。
            </div>
            <div class="box-list">
              <ul>
                <li>
                  <a @click="goView('government')">
                    <div class="li-img"><img src="@/assets/zhengfu.png" alt=""></div>
                    <div class="li-title">政府大数据</div>
                    <div class="li-text">基于分析、评价、预测、预警、建议等决策抓手，为政府、行业、企业和民生提供精准决策</div>
                  </a>
                </li>
                <li class="li-active">
                  <a @click="goView('enterprise')">
                    <div class="li-img"><img src="@/assets/qiye.png" alt=""></div>
                    <div class="li-title">企业数字化转型</div>
                    <div class="li-text">企业是经济运行的细胞体，是数字化转型的主要承担</div>
                  </a>
                </li>
                <li>
                  <a @click="goView('education')">
                    <div class="li-img"><img src="@/assets/xuexiao.png" alt=""></div>
                    <div class="li-title">教育与培训</div>
                    <div class="li-text">通过与服务于高校教育与企业培训的生态伙伴合作，为高校的大数据应用教学提供实际场景、数据、无编码教学平台和课件素材</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="home-mode partner" id="partner"  style="height: 558px;">
        <div class="mode-cont" style="position: relative;margin:0 auto;left:0px;">
          <div class="cont-title">
            <span class="title-en">PARYNERS</span><span class="title-ch">合作伙伴</span>
            <img class="title-box" src="@/assets/box.png" alt="">
          </div>
          <div id="demo" class="carousel slide" data-ride="carousel">
            <el-carousel trigger="click" height="350px"  arrow="never">
              <el-carousel-item v-for="(carousel,index) in carouselImg" :key="index">
                <div claas="carousel-item">
                  <li class="li" v-for="(item,idx) in carousel" :key="idx">
                    <a href="">
                      <img :src="item.url" :alt="item.url">
                    </a>
                  </li>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="home-mode" id="journalism" style="height: 511px;">
        <div class="mode-cont">
          <div class="cont-title">
            <span class="title-en">NEWS</span><span class="title-ch">新闻中心</span>
            <img class="title-box" src="@/assets/box.png" alt="">
          </div>
          <div class="news">
            <div class="news-list">
              <ul>
                <li v-for="(item,index) in new_list" :key="index" @click="go_single(item)">
                  <div class="news-img"><img :src="item.url" alt=""></div>
                  <a class="news-mask"></a>
                  <div class="new-cont">
                    <a>
                      <div class="news-title">{{item.title}}</div>
                      <div class="news-line"></div>
                      <div class="news-text">{{item.text}}</div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="news-more">
            <a @click="goView('news')">
              <div style="width: 136px;height:40px;border-radius:40px;border:1px solid #e35150;color:#e35150;font-weight:bold;font-size:16px;display-inline-block;line-height:38px">查看更多 <span style="font-size: 18px;">＞</span></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      carouselImg: [
        [{
          name: '1',
          url: require('@/assets/link1.jpg'),
          harf: ''
        },
        {
          name: '2',
          url: require('@/assets/link2.jpg'),
          harf: ''
        },
        {
          name: '3',
          url: require('@/assets/link3.jpg'),
          harf: ''
        },
        {
          name: '4',
          url: require('@/assets/link4.jpg'),
          harf: ''
        },
        {
          name: '5',
          url: require('@/assets/link5.jpg'),
          harf: ''
        },
        {
          name: '6',
          url: require('@/assets/link6.jpg'),
          harf: ''
        },
        {
          name: '7',
          url: require('@/assets/link7.jpg'),
          harf: ''
        },
        {
          name: '8',
          url: require('@/assets/link8.jpg'),
          harf: ''
        }],
        [{
          name: '9',
          url: require('@/assets/link9.jpg'),
          harf: ''
        },{
          name: '10',
          url: require('@/assets/link10.jpg'),
          harf: ''
        },]
      ],
      new_list: [{
        title: '2019-03-09',
        url: require('@/assets/热门配图-1-221x183.png'),
        text: '部盾科技CEO部瑞志博士与上海证券交易所联合课题项目成功通过验收',
        id: '1',
      },{
        title: '2018-10-10',
        url: require('@/assets/s-3.png'),
        text: '部盾科技CEO部瑞志博士与上海金融圈分享金融风险防范',
        id: '2',
      },{
        title: '2018-12-20',
        url: require('@/assets/image.png'),
        text: '部盾科技助力ATA发布《2018年ATA就业力报告》',
        id: '3',
      },{
        title: '2019-06-01',
        url: require('@/assets/热门图-133x183.jpg'),
        text: '部盾科技获得《税务研究》杂志征文优秀奖',
        id: '4',
      }]
    };
  },
  methods: {
    goView(name) {
      this.$router.push({name: name})
    },
    go_single(data) {
      this.$router.push({ path: '/NewsDetails', query: {id: data.id}})
    },
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>